import React from "react";
import { Users } from "lucide-react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { Textarea } from "@/components/ui/textarea";
import { field } from "@/components/PageHeader";

export default function SongNotes({ item, locked, onChange, onClose }) {
  return (
    <Dialog open onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="max-w-xl bg-[#0f1012] border-white/10" data-testid="song-notes">
        <DialogHeader>
          <div className="text-[11px] tracking-[.3em] uppercase text-amber-400/80 flex items-center gap-2"><span className="w-2.5 h-2.5 rounded-full" style={{ background: item.color || "#fbbf24" }} />Song notes · {item.key} · {item.bpm} BPM</div>
          <DialogTitle className="text-2xl font-semibold">{item.title}</DialogTitle>
          <DialogDescription className="flex items-center gap-1.5"><Users className="w-3.5 h-3.5" />Shared with everyone in this session — anyone can read and edit.</DialogDescription>
        </DialogHeader>
        <Textarea autoFocus disabled={locked} value={item.song_notes || ""} onChange={(e) => onChange(e.target.value)} rows={12} className={field + " text-sm"} placeholder="Arrangement, form, who solos where, lyric changes, gear, anything the team needs to know about this song…" data-testid="song-notes-text" />
        <div className="text-[11px] text-zinc-500">{locked ? "Session is locked — notes are read-only." : "Autosaves and syncs to your collaborators within a few seconds."}</div>
      </DialogContent>
    </Dialog>
  );
}
